import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '../model/log-container.model';
import { TerminalContextConstants } from '../model/terminal-context-constants';
import { ProcessSelectionActionType, ProcessSelectOption } from '../widgets/terminal/process-selection/process-selection.model';

export class ProcessSelectionController extends AbstractStepController {

  private dialogService: DialogService

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedProcessOption') {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
    }
  }

  onRegisterToDashboardContext() {
  }

  private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
    this.wizardComponent.stopInactivityMonitoring();
    if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
      this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
    } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
      this.wizardComponent.next(selectedProcessOption.processStepKey);
    } else {
      console.error('Missconfigured processselectionoption. neither flow or step defined', selectedProcessOption);
    }
  }

  public handleFlow(): FlowStepHandleResult {

    this.dashboardContext.setContextValue('dashboardConfiguration', this.wizardComponent.currentStep.dashboardConfiguration);

    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('registration type selection started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    this.dialogService.showConfirm('tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message').afterClosed().subscribe(confirm => {
        if (confirm) {
          this.wizardComponent.stopInactivityMonitoring();
          this.wizardComponent.restartWizard();
        }
      });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }
}
